import { useMutation } from '@tanstack/react-query'

import { AuthService } from 'services/auth'
import { TokenRequest, TokenResponse } from 'services/auth/types'
import { handleSetCookies } from 'utilities/auth'

async function login(request: TokenRequest) {
  return await AuthService.login(request)
}

export const usePostAuth = (userId: string) => {
  const {
    data: credentials,
    isLoading,
    mutate,
    error,
  } = useMutation((request: TokenRequest) => login(request), {
    retry: false,
    onSuccess: (data: TokenResponse) => {
      handleSetCookies({
        userId,
        accessToken: data.accessToken,
        refreshToken: data.refreshToken || '',
      })

      sessionStorage.setItem('userId', userId)
      sessionStorage.setItem('accessToken', data.accessToken)
      sessionStorage.setItem('refreshToken', data.accessToken)
    },
  })

  return { credentials, isLoading, mutate, error }
}
